import { post } from "@readai/common/api";
import type { PostCalendarEventBody } from "@readai/common/types/calendarTypes";
import { sanitize } from "@readai/common/utils";

export const postCalendarEvent = async (body: PostCalendarEventBody) => {
  return post("/calendar_events_metadata", sanitize(body), { withCreds: true });
};
